import TattooGallery from "../../components/TattooGallery/TattooGallery";
import styles from "./Work.module.css";

const Work = () => {
  return (
    <section className={styles.wrapper}>
      <TattooGallery />
    </section>
  );
};

export default Work;
